import Image from 'app/Components/Shared/Image/image';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CellularDeviceBlockData from 'app/Models/Content/CellularDeviceBlockData';
import CellularDevicesItemsBlockData from 'app/Models/Content/CellularDevicesItemsBlockData';
import React from 'react';
import {Container} from 'reactstrap';
import CellularDeviceBlock from '../CellularDeviceBlock';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import {isMobile} from 'react-device-detect';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination, Navigation} from 'swiper';
import 'swiper/swiper.scss';

SwiperCore.use([Pagination, Navigation]);

const CellularDevicesItemsBlock = (props: ComponentProps<CellularDevicesItemsBlockData>) => {
  const {data, context} = props;
  return (
    <BlockWrapper props={props} disableFadeIn={!isMobile}>
      <div className='CellularDevicesItemsBlock'>
        {/* mobile */}
        <Swiper
          navigation={{
            nextEl: '.-swiper-nextEl',
            prevEl: '.-swiper-prevEl',
          }}
          pagination={{clickable: true}}
          simulateTouch={false}
          spaceBetween={7}
          slidesPerView={1.2}
          centeredSlides
          loop
          className='CellularDevicesItemsBlock__swiper d-md-none'>
          {data.cellularItems.expandedValue.map((item: CellularDeviceBlockData, i) => (
            <SwiperSlide key={i}>
              <CellularDeviceBlock data={item} context={context} />
            </SwiperSlide>
          ))}
          <>
            <div className='-swiper-nextEl'>
              <Image src={require('./images/left-icon.svg')} />
            </div>
            <div className='-swiper-prevEl'>
              <Image src={require('./images/right-icon.svg')} />
            </div>
          </>
        </Swiper>

        {/* desktop */}
        <Container className='d-none d-md-block'>
          <div className='CellularDevicesItemsBlock__items'>
            <ContentArea noWrap context={context} data={data.cellularItems} />
          </div>
        </Container>
      </div>
    </BlockWrapper>
  );
};

export default CellularDevicesItemsBlock;
